export default "__VITE_ASSET__CrpuzTYr__"